module.exports = __webpack_public_path__ + "assets/images/facebook.e085e238.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-media/facebook.svg
// module id = 348
// module chunks = 1